import { TableType } from '@common/ts/enums';

// Pagination parameter utilities
export const getPaginationParamPage = (type: TableType): string => `${type}_page`;

// Sorting parameter utilities
export const getSortingParamBy = (type: TableType): string => `sort_${type}_by`;
export const getSortingParamType = (type: TableType): string => `sort_${type}_type`;

// Filtering parameter utilities
export const getFilteringParamName = (type: TableType, columnName: string): string =>
  `${type}_${columnName}`;
